export default __webpack_public_path__ + "static/media/tracer-unit-flat.bd2789b7.svg";